import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-objectif-content',
  templateUrl: './objectif-content.component.html',
  styleUrls: ['./objectif-content.component.scss']
})
export class ObjectifContentComponent {
  @Input() listPerformances: any[] = [];
  @Input() typeVisualisation: string;
  @Input() resultat_objectif_performances: number;
  @Input() nbre_rubrique_evaluee: number;
  @Input() appreciation_performance: string;
  @Input() commentaire: string;

  @Output() savePerformances = new EventEmitter<void>();
  @Output() recupererData = new EventEmitter<string>();
  @Output() isChecked = new EventEmitter<{ performanceId: number, notationId: number }>();
  @Output() resetField = new EventEmitter<{ mode: string, performance: any }>();
  @Output() commentaireChange = new EventEmitter<string>();

  onCommentaireChange(value: string) {
    this.commentaireChange.emit(value);
  }

  onSave() {
    this.savePerformances.emit();
  }

  onRecupererData(dataType: string) {
    this.recupererData.emit(dataType);
  }

  onChecked(performanceId: number, notationId: number) {
    this.isChecked.emit({ performanceId, notationId });
  }

  onResetField(mode: string, performance: any) {
    this.resetField.emit({ mode, performance });
  }
}
